<template>
  <div class="page-bg page">
    <SubHeader :title="headerTitle"></SubHeader>
    <OrderTags :status="status"></OrderTags>
    <div class="main">
      <router-view></router-view>
    </div>
  </div>
</template>


<script>
import SubHeader from "../../../components/sub_header";
import OrderTags from "../../../components/order_tags";
export default {
  name: "my-order",
  data() {
    return {
      status: this.$route.query.status ? this.$route.query.status : "all",
      headerTitle: "我的订单",
    };
  },
  components: {
    SubHeader,
    OrderTags,
  },
  methods: {},
  mounted() {},
  beforeRouteUpdate(to, from, next) {
    this.status = to.query.status;
    next();
  },
  created() {
    // this.$utils.safeUser(this);
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  background-size: cover;
  padding-bottom: 1.2rem;
  box-sizing: border-box;
  height: 100vh;
}

.main {
  width: 100%;
  padding: 0.3rem 0 0;
  box-sizing: border-box;
  height: calc(100vh - 1.75rem);
  position: relative;
  // overflow-y: auto;
}
</style>

